import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';

class OrderSummary09Service extends React.Component {
  static propTypes = {
    orderDetailInfo: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
    currentLocale: PropTypes.string.isRequired,
  };

  getServiceTypeIndex() {
    if (this.props.currentLocale === 'en-SG') {
      switch (this.props.orderDetailInfo.service_type) {
        case 'delivery':
          return 0;
        case 'transport':
          return 1;
        default:
          return 2;
      }
    } else {
      switch (this.props.orderDetailInfo.service_type) {
        case 'transport':
          return 0;
        case 'delivery':
          return 1;
        case 'moving':
          return 2;
        default:
          return 3;
      }
    }
  }
  render() {
    return (
      <div className={`${s.summaryVehicle}`}>
        <p className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_summary_service_title}
        </p>
        <hr className={s2.hrBottom} />
        <span>
          {
            this.props.modelData.order_model_data.service_types[
              this.getServiceTypeIndex()
            ].title
          }
        </span>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(OrderSummary09Service),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary09Service/OrderSummary09Service.js